export default __webpack_public_path__ + "static/layout-example-dark-150b05ca3a45ed394b034bf4f79989b9.png";